import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const dashboardDetail = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      grafikMerchant: null,
      grafikAggregator: null,
      grafikTransaction: null,
      grafikSalesVolume: null,
      merchantTot: null,
    };
  },

  mutations: {
    getDataGrafikMerchant(state, { payload }) {
      state.grafikMerchant = payload.data;
    },

    getDataGrafikAggregator(state, { payload }) {
      state.grafikAggregator = payload.data;
    },

    getDataGrafikTransaction(state, { payload }) {
      state.grafikTransaction = payload.data;
    },

    getDataGrafikSalesVolume(state, { payload }) {
      state.grafikSalesVolume = payload.data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setLoading(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    // tab1
    async getCountMerchant(ctx, { date, search }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant/get-data-card-merchant`;

      const responseData = await postApi(ctx, urlApi, data);

      return responseData?.data.total_merchant;
    },

    async getCountAggregator(ctx, { date, search }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant/get-data-card-aggregator`;

      const responseData = await postApi(ctx, urlApi, data);

      return responseData?.data.total_aggregator;
    },

    async getGrafikMerchant(ctx, { year, date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        year,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant/get-data-grafik-merchant`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('getDataGrafikMerchant', { payload: responseData });
      }
    },

    async getGrafikAggregator(ctx, { year, date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        year,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant/get-data-grafik-aggregator`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('getDataGrafikAggregator', { payload: responseData });
      }
    },

    // tab 2
    async getCountTransaction(ctx, { date, searchtrans }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        searchtrans,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/transaction/get-data-card-total`;

      const responseData = await postApi(ctx, urlApi, data);

      return responseData?.data.total_transaction;
    },

    async getCountSalesVolum(ctx, { date, searchtrans }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        searchtrans,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/transaction/get-data-card-volume`;

      const responseData = await postApi(ctx, urlApi, data);

      return responseData?.data.total_amount;
    },

    async getGrafikTransaction(ctx, { year, date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        year,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/transaction/get-data-grafik-total`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('getDataGrafikTransaction', { payload: responseData });
      }
    },

    async getGrafikSalesVolume(ctx, { year, date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        year,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/transaction/get-data-grafik-volume`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('getDataGrafikSalesVolume', { payload: responseData });
      }
    },
  },
};
export default dashboardDetail;
